export default __webpack_public_path__ + "static/media/tour-10.6a185e4e.png";